// extracted by css-extract-rspack-plugin
export default {"root":"root-GkKPUn","input":"input-a2n37C","label":"label-oQfHQI","sm":"sm-PPbPAE","md":"md-VSDwGG"};